/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./LoginFaq.css";
import { Link } from "react-router-dom";
import { simpleFetch } from "../../restWrapper";
import PropTypes from "prop-types";
import { getOrganizationID, validatePlatformMatch } from "../../assets/helper";
import { PLATFORM } from "../../config";
import { rememberOrgTitle } from "../../assets/orgTitle";

class LoginFaq extends Component {
  constructor(props) {
    super(props);
    let subdomain = "";
    let domain = "";
    let isCustomDomain = false;
    try {
      subdomain = getOrganizationID(window.location.href).subdomain;
      domain = getOrganizationID(window.location.href).domain;
      isCustomDomain = getOrganizationID(window.location.href).isCustomDomain;      
    } catch (e) {
      this.props.history.push({ pathname: "/" + this.props.language });
    }

    this.state = {
      fetching: true,
      // To avoid inital fetching & InfiniteScroll fetching
      // At the same time
      subdomain: subdomain,
      domain: domain,
      isCustomDomain: isCustomDomain,
    };
  }

  componentDidMount() {
    if (this.state.subdomain === null || this.state.subdomain === "") {
      return false;
    }
    if (this.state.subdomain === "www") {
      return false;
    }

    simpleFetch("/donors/organization", "GET", {
      subDomain: this.state.isCustomDomain ? this.state.domain : this.state.subdomain,
      isCustomDomain: this.state.isCustomDomain,
    }).then((res) => {
      if (res.status !== 200) {
        this.props.history.push({ pathname: "/" + this.props.language });
        return false;
      }

      rememberOrgTitle(res.body.organizationObj.organizationName);

      // Validate platform matches organization type
      const platformMatch = validatePlatformMatch(
        res.body.organizationObj.organizationType,
        PLATFORM
      );

      if (!platformMatch) {
        // console.error("Cannot display FAQ page: platform mismatch");
        this.props.history.push({ pathname: "/" + this.props.language });
        return false;
      }

      this.setState({
        ...this.state,
        ...{
          fetching: false,
          headerColor: res.body.organizationObj.headerColor,
          buttonColor: res.body.organizationObj.buttonColor,
          progressBarColor: res.body.organizationObj.progressBarColor,
          logo: res.body.organizationObj.logo,
        },
      });
    });
  }
  render() {
    if (this.state.fetching) {
      return (
        <div className="SelectMission-emptyPage">
          <div className="SelectMission-center">
            <div className="SelectMission-btm-load"></div>
          </div>
        </div>
      );
    }

    const languageObj = this.props.languageObj;

    return (
      <div className="LoginFaq-view">
        <div className="LoginFaq-prompt">
          <Link to="/LoginPrompt">
            <div className="LoginFaq-backContainer">
              <div className="LoginFaq-back">
                <div className="LoginFaq-backBtn" />
                <div className="LoginFaq-backText">{languageObj.backTxt}</div>
              </div>
            </div>
          </Link>

          <a
            href="https://check.plus/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="LoginFaq-checkplusIcn">
              <div className="LoginFaq-checkplusLogo" />
              <div className="LoginFaq-loginText"></div>
            </div>
          </a>

          <div className="LoginFaq-content">
            <div className="LoginFaq-question">{languageObj.question[0]}</div>

            <div className="LoginFaq-answer">{languageObj.answer[0]}</div>

            <div className="LoginFaq-question">{languageObj.question[1]}</div>

            <div className="LoginFaq-answer">{languageObj.answer[1]}</div>

            <div className="LoginFaq-question">{languageObj.question[2]}</div>

            <div className="LoginFaq-answer">{languageObj.answer[2]}</div>
          </div>

          <div className="LoginFaq-chin" />
        </div>
      </div>
    );
  }
}

LoginFaq.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
};

export default LoginFaq;
